import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20with%20crimson%20and%20deep%20golden%20tones%20blending%20smoothly%2C%20luxurious%20texture%20with%20soft%20flowing%20curves%2C%20elegant%20dark%20background%20with%20warm%20light%20accents%2C%20premium%20sophisticated%20feel&width=1800&height=500&seq=cta-bg-kaiyun-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/85 to-primary-900/90" />

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-8">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold text-primary-700 bg-background-50 hover:bg-accent-100 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}